module.exports = __webpack_public_path__ + "media/images/icon-comm-menu-e3cab1dd88fd1252d02c2605cd2d957d.svg";